export enum HallowABFlag {
  ApplePaySheetWeb = "apple_pay_sheet_web",
  WebFirstMonthFreeText = "web_first_month_free_text",
  WebFoundingStory = "web_founding_story",
  WebMediumOnboarding = "web_medium_onboarding",
  WebHomepageCTADestination = "web_homepage_cta_destination",
  PhilippinesMediumOnboarding = "philippines_medium_onboarding",
  WebVariableTrialLength = "web_variable_trial_length",
  WebSubscreenArrowButton = "web_subscreen_arrow_button",
  WebFamilyPlanTest = "family_plan_sub_screen_web_v1",
  WebTrialToggle = "web_trial_toggle",
  FamilyPlanOneClickUpgrade = "family_plan_upgrade",
}
